<template>
    <label class="checkbox">
        <span class="checkbox__input">
            <input type="checkbox" :value="val" v-model="checked" @change="onChange" />
            <span></span>
        </span>
        <span class="checkbox__label"><slot></slot></span>
    </label>
</template>


<script>
	export default {
		props: ["value", "val"],
        data() {
            return {
                proxy: false
            };
        },
        computed: {
            checked: {
                get() {
                        return this.value;
                    },
                    set(value) {
                        this.proxy = value;
                    }
            }
        },
        methods: {
            onChange(event) {
                this.$emit("input", this.proxy);
                this.$emit("clicked", event)
            }
        }
	}
</script>
<style lang="scss" scoped>
    @import '../scss/variables';

    .checkbox {
        position: relative;
        display: flex;
        padding: 0.25rem 0.5rem;;
        align-items: center;
        color: $color-dove-gray;
        font-size: 1rem;
        // line-height: 20px;
        white-space: nowrap;
        cursor: pointer;
        user-select: none;
        &__input {
            position: relative;
            display: block;
            width: 1rem;
            height: 1rem;
            margin-right: 0.25rem;
            input {
                position: absolute;
                opacity: 0.01;
                pointer-events: none;
            }
            input:checked + span:after {
                opacity: 1;
                transform: scale(1);
            }
            span {
                position: absolute;
                top: 0;
                left: 0;
                width: 1rem;
                height: 1rem;
                &:before,
                &:after {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    display: block;
                    speak: none;
                }
                &:before {
                    border-radius: 4px;
                    border: 0.125rem solid $color-boston-blue;
                }
                &:after {
                    top: 0.125rem;
                    left: 0.125rem;
                    right: 0.125rem;
                    bottom: 0.125rem;
                    content: "\E608";
                    font-family: element-icons;
                    font-size: 0.5rem;
                    line-height: 1.5;
                    color: $color-boston-blue;
                    text-align: center;
                    transform: scale(0);
                    transform-origin: center;
                    transition: all .2s $animation-ease;
                }
            }
        }
        &__label {

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/checkbox.vue